/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Partner_Org_Contract_State_ActiveInputs */



/**
* | output |
* | --- |
* | "Running until {date}. Covered by the purchase order — these periods are never invoiced." |
*
* @param {Partner_Org_Contract_State_ActiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_state_active = /** @type {((inputs: Partner_Org_Contract_State_ActiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_State_ActiveInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Läuft bis ${i?.date}. Durch die Bestellung abgedeckt — diese Perioden werden nie in Rechnung gestellt.`)
	return /** @type {LocalizedString} */ (`Running until ${i?.date}. Covered by the purchase order — these periods are never invoiced.`)
});